import { useState } from 'react';
import Slider from "react-slick";
import Carousel from 'react-bootstrap/Carousel';
// import { useGSAP } from "@gsap/react";
import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/all';
// import SplitType from 'split-type'
import MakeAppoinment from '../components/make-appoinment';


// import ExampleCarouselImage from 'components/ExampleCarouselImage';
// /Components
import Header from '../components/header'
import Footer from '../components/footer'

import useGaspAnimations from '../components/useGsapAnimations'




 gsap.registerPlugin(ScrollTrigger)  
function Home() {

useGaspAnimations();

 const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)


    // var settings2 = {
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     initialSlide: 0,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     responsive: [
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 4,
    //           slidesToScroll: 4,
    //           infinite: true,
    //           dots: true
    //         }
    //       },
    //       {
    //         breakpoint: 1000,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 3,
    //           initialSlide: 2
    //         }
    //       },
    //       {
    //         breakpoint: 480,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    //   };

      var settings3 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
         {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
  


    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      };

    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
      setIndex(selectedIndex);
    };


    // // gasp

//     let typeSplit = new SplitType('.hero', {
//   types: 'lines, words, chars',
//   tagName: 'span'
// })

// gsap.from('.hero .line', {
//   y: '100%',
//   opacity: 0,
//   duration: 0.5,
//   ease: 'power1.out',
//   stagger: 0.1,
  
//   scrollTrigger: {
//     trigger: '.hero',
//     start: 'top center',
    
//   }
// })
    return (   
        <section id="smooth-wrapper" className='landing-page-home'>
            <Header/>
            <main>
                    {/* <!--Start Preloader --> */}
                    {/* <div className="preloader"></div> */}
                    {/* <!--End Preloader -->   */}

                    {/* <!--Start rev slider wrapper-->      */}
                    <section className="revwrapper">
                        <div className="revslider">
                        <Carousel activeIndex={index} onSelect={handleSelect}>
                            <Carousel.Item>
                            <img src="assets/images/slides/wall-1.webp"  alt="" className="d-block w-100"/>
                                                      <Carousel.Caption>
                            <div className="tp-parallax-wrap">
                        <div className="tp-loop-wrap">
                            <div className="tp-mask-wrap">
                                <div className="tp-caption  tp-resizeme">
                                    <div className="slide-content-box mar-lft">
                                       
                                        <h1 className="hero title-anim"> 
                                            <img src="assets/images/25yearsofexcellence.png"  alt="25yearsofexcellence.png" className="d-block w-25-years"/>
                                            Delivering Sustainable and Reliable Refrigeration Systems for Over 25 Years</h1>
                                        <br/> 
                                        {/* <p className="hero">
                                 Sustainable, Energy-Efficient and Reliable  Cooling & Freezing solutions that minimize environmental impact, enhance quality of life, and drive positive change.. 
                            </p> */}
                                    </div>
                                    <div className="slide-content-box mar-lft">
                                        <div className="button hero bdFadeUp">
                                            <a href="/about-indusref">More About Us</a>     
                                            <a className="btn-style-two" href="/indusref-products">Our Products</a>     
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                            <img src="assets/images/slides/wall-2.webp"  alt="" className="d-block w-100"/>
                                                       <Carousel.Caption>
                            <div className="tp-parallax-wrap">
                        <div className="tp-loop-wrap">
                            <div className="tp-mask-wrap">
                                <div className="tp-caption  tp-resizeme">
                                    <div className="slide-content-box mar-lft">
                                      <h1 className="hero title-anim">
                                        Exceeding Customer Expectation for Energy-Efficient Cooling, Chilling, and Freezing Solutions.
                                      </h1>
                                      <br/> 
                                        {/* <p className="hero">
                                 Sustainable, Energy-Efficient and Reliable  Cooling & Freezing solutions that minimize environmental impact, enhance quality of life, and drive positive change.. 
                            </p> */}
                                    </div>
                                    <div className="slide-content-box mar-lft">
                                        <div className="button hero bdFadeUp">
                                            <a href="/about-indusref">More About Us</a>     
                                            <a className="btn-style-two" href="/indusref-products">Our Products</a>     
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        </Carousel.Caption>
                            </Carousel.Item>
                            <Carousel.Item>
                            <img src="assets/images/slides/wall-3.webp"  alt="" className="d-block w-100"/>
                                                        <Carousel.Caption>
                            <div className="tp-parallax-wrap">
                        <div className="tp-loop-wrap">
                            <div className="tp-mask-wrap">
                                <div className="tp-caption  tp-resizeme">
                                    <div className="slide-content-box mar-lft">
                                         <h1 className="hero title-anim">
                                              Solutions that Minimize Environmental Impact and Enhance Quality of Life   
                                         </h1>
                                         <br/> 
                                        {/* <p className="hero">
                                Sustainable, Energy-Efficient and Reliable  Cooling & Freezing solutions that minimize environmental impact, enhance quality of life, and drive positive change.. 
                            </p> */}
                                    </div>
                                    <div className="slide-content-box mar-lft">
                                        <div className="button hero bdFadeUp">
                                            <a className="" href="/about-indusref">More About Us</a>     
                                            <a className="btn-style-two" href="/indusref-products">Our Products</a>     
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        </Carousel.Caption>
                            </Carousel.Item>


 {/* <Carousel.Item>
                            <img src="assets/images/slides/wall-4.webp"  alt="" className="d-block w-100"/>
                                                        <Carousel.Caption>
                            <div className="tp-parallax-wrap">
                        <div className="tp-loop-wrap">
                            <div className="tp-mask-wrap">
                                <div className="tp-caption  tp-resizeme">
                                    <div className="slide-content-box mar-lft">
                                         <h1 className="hero title-anim">SUSTAINABLE COOLING AND REFRIGERATION SOLUTIONS</h1>
                                         <br/> 
                                    </div>
                                    <div className="slide-content-box mar-lft bdFadeUp">
                                        <div className="button hero">
                                            <a className="" href="/about-indusref">More About Us</a>     
                                            <a className="btn-style-two" href="/indusref-products">Our Products</a>     
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        </Carousel.Caption>
                            </Carousel.Item> */}
                            
                        </Carousel>
                        


                        </div>
                    </section>
                    {/* <!--End rev slider wrapper-->  */}
                        

                    {/* Start Vision */}
                      <section className="welcome-area ">
                         <div className="container">
                              <div className="title text-center sec-title">
                                    <h1 className='title-anim'><span>Vision</span></h1>
                                        <h2 className='title-anim'>
  To  protect the environment and enhance  quality of life through ethical practices 
  <br/>and sustainable energy efficient cooling and freezing solutions.
                                        </h2>
                                  
                                   
                              </div>
                             
                         </div>
                      </section>

                    {/* <!--Start welcome area--> */}
                    <section className="welcome-area white-bg">
                        <div className="container">
                            <div className="title text-center sec-title">
                                  <h1 className='title-anim '><span>Our Products</span></h1>
                                <h2 className='title-anim'>Sustainable, Energy-Efficient and Reliable  Cooling & Freezing solutions <br/>that minimize environmental impact, enhance quality of life, and drive positive change.</h2>
                            </div>
                            <div className="row">
                                {/* <!--Start single item--> */}
                                <a href="/industrial-refrigeration" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Industrial-Refrigeration-Refpacks.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-car"></span> */}
                                                    <img src='assets/images/Productiocns/01-black.webp' alt='icons'/> 
                                                </div>
                                             
                                                <div className="text">
                                                    <h3>Skid Mounted Refrigeration Pack</h3>
                                                    {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-car"></span> */}
                                                    <img src='assets/images/Productiocns/01-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Skid Mounted Refrigeration Pack</h3>
                                                    <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                              
                                                 <ul className="pull-left">
                                                        <li>Low Charge Ammonia</li>
                                                        <li>Pump feed Ammonia </li>
                                                        <li>Freon DX </li>
                                                        <li>CO2  Subcritical </li>
                                                        <li>CO2 Transcritical</li>
                                                    </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-car"></span> */}
                                                     {/* <img src='assets/images/Productiocns/01-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}
                                {/* <!--Start single item--> */}
                                <a href="/cooling-and-chilling" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Cooling-&-Chilling-Systems.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-car"></span> */}
                                                    <img src='assets/images/Productiocns/02-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Process Refrigeration Systems </h3>
                                                      {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-fire"></span> */}
                                                    <img src='assets/images/Productiocns/02-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Process Refrigeration Systems </h3>
                                               <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                                
                                                <ul className="pull-left">
                                                    <li>Process & Instant Milk Chiller</li>
                                                    <li>Refrigerated Sea Water </li>
                                                    <li>Boil Off Gas Condensing system</li>
                                                    <li>Gas Liquification</li>
                                                    <li>Turbine Inlet Air cooling system</li>
                                                    <li>CO2 Atmospheric & Vapouriser</li>
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-fire"></span> */}
                                                    {/* <img src='assets/images/Productiocns/02-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                               </a>
                                {/* <!--End single item--> */}
                                {/* <!--Start single item--> */}
                                <a href="/heat-pumps" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Heat-Pumps.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/03-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Heat Pumps</h3>
                                                       {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    <img src='assets/images/Productiocns/03-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Heat Pumps</h3>
                                                   <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                                 
                                                <ul className="pull-left">
                                                    <li>Air Source Heat Pump</li>
                                                    <li>Water Source Heat Pump</li>
                                                    <li>Dual Source Heat Pump</li>
                                                    <li>Hybrid Heat Pump</li>

                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                            {/* <img src='assets/images/Productiocns/03-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}

                                {/* <!--Start single item--> */}
                                <a href="/ICE-production-systems" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Container-Plant.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/04-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3> ICE Production Systems</h3>
                                                {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/04-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3> ICE Production Systems</h3>
                                                    <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                               
                                                <ul className="pull-left">
                                                  <ul>
                                                    <li>Block & Flake ice systems</li>
                                                    <li>Tube ice systems</li>
                                                    <li>Plate / slice ice systems </li>
                                                    <li>Slurry ice systems </li>
                                                    <li>Cube / commercial ice systems</li>
                                                  </ul> 
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                       {/* <img src='assets/images/Productiocns/04-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}

                                 {/* <!--Start single item--> */}
                                 <a href="/ammonia-recirculator-package" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Economizer.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/05-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Ammonia Liquid  Recirculator Package </h3>
                                              {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/05-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Ammonia Liquid  Recirculator Package </h3>
                                                     <span>Read More</span>
                                                    {/* <span>Open Flash...</span> */}
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                               
                                                <ul className="pull-left">
                                                    <li>Ice Manufacturing</li>
                                                    <li>Cold Storage</li>
                                                    <li>Food Processing</li>
                                                    <li>Dairy & Beverage</li>
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    {/* <img src='assets/images/Productiocns/05-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                               </a>
                                {/* <!--End single item--> */}

                                 {/* <!--Start single item--> */}
                                 <a href="/cooling-condenser" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/cooledcondenser.jpg" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/09-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Cooling Condenser</h3>
                                                     {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/09-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Cooling Condenser</h3>
                                                    <span> Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                             
                                                <ul className="pull-left">
                                                    <li>Evaporative Condensor</li>
                                                    <li>Shell and Tube water cooled</li>
                                                    <li>Air cooled</li>   
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                            {/* <img src='assets/images/Productiocns/06-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                               </a>
                                {/* <!--End single item--> */}

                                 {/* <!--Start single item--> */}
                                 <a href="/pressure-vessels" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Pressure-Vessels.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/07-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Pressure Vessels</h3>
                                                    {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/07-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Pressure Vessels</h3>
                                                    <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                                
                                                <ul className="pull-left">
                                                    <li>Suction Accumulators</li>
                                                    <li>Receivers</li>
                                                    <li>Chiller Barrels and Subcoolers</li>
                                                    <li>Oil Separators</li>
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    {/* <img src='assets/images/Productiocns/07-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}


                                     {/* <!--Start single item--> */}
                                 <a href="/freezers" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/IQF_Freezer_Dairy_370x200.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/10-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Freezers</h3>
                                                    {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/10-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Freezers</h3>
                                                    <span>Read More</span>
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                                
                                              <ul className="pull-left">
                                                    <li>IQF & Blast Freezer </li>
                                                    <li>Contact Freezer </li>
                                                    <li>Compact Freezer </li>
                                                    <li>Fluidised bed Freezer</li>
                                                    <li>Brine Freezer</li>
                                                </ul>
                                                <div className="icon-holder">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    {/* <img src='assets/images/Productiocns/07-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}

 {/* <!--Start single item--> */}
                                    <a href="/control-systems" className="col-md-4 bdFadeUp">
                                    <div className="single-item imghvr-hinge-down">
                                        <div className="inner-content">
                                            <div className="img-holder">
                                                <img src="assets/images/OurProducts/Support-Services-.webp" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                    <img src='assets/images/Productiocns/08-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Control Systems  </h3>
                                                  {/* <span>Read More</span> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="overlay-content">
                                            <div className="text-holder">
                                                <div className="icon">
                                                    {/* <span className="flaticon-technology-2"></span> */}
                                                     <img src='assets/images/Productiocns/08-black.webp' alt='icons'/> 
                                                </div>
                                                <div className="text">
                                                    <h3>Control Systems  </h3>
                                                    {/* <span>Great explorer of truth</span> */}
                                                </div>
                                            </div> 
                                            <div className="bottom-text-holder">
                                                
                                                <ul className="pull-left">
                                                        <li>Sensors and Controls </li>
                                                        <li>Control Panel</li>
                                                        <li>SCADA system</li>
                                                        <li>Automation</li>
                                                        <li>Monitoring Software</li>
                                                    {/* <li>Furnace Repair</li>    
                                                    <li>Heater Repair</li>    
                                                    <li>Thermostats</li>    
                                                    <li>Emergency Services</li>       */}
                                                </ul>
                                                <div className="icon-holder">
                                                           {/* <img src='assets/images/Productiocns/08-black.webp' alt='icons'/>  */}
                                                </div>
                                            </div>   
                                        </div>
                                    </div>
                                </a>
                                {/* <!--End single item--> */}
                            

                                 
                            
                            </div>
                        </div>
                    </section>
                    {/* <!--End welcome area--> */}

                    {/* <!--Start about us area--> */}
                    <section className="about-us-area">
                        <div className="container">
                            <div className="sec-title">
                                <h1><span>About Us</span></h1>
                                 <div className="title">
                                            <h3>ISO 9001:2015</h3>
                                        </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 bdFadeLeft">
                                    <div className="img-holder">
                                        <img src="assets/images/About-Us.png" alt="indusrefServices"/>
                                    </div>   
                                     
                                </div>
                                <div className="col-md-4">
                                    <div className="middle-text-box">
                                        <div className="single-item top bdFadeUp">
                                            <h3>Business Objectives</h3>
                                            <p>
                                                  Indus Refregeration Pvt Ltd, is an Engineering,  company specialized in   Engineering, Consulting, Erection and Commissioning of Industrial Refrigeration  projects in Seafood & Meat, Fruits & Vegetables, Milk & Dairy, Cold Storage, Petrochemical, Pharmaceutical, Power plants and Beverage industries.
                                            </p>
                                        </div> 
                                        <div className="single-item bdFadeUp">
                                            <h3>Deliverables </h3>
                                            <ul>
                                                <li className='clouser'>Engineering of Industrial refrigeration plant/Systems.</li>
                                                <li className='clouser'>Consulting on process refrigeration.</li>
                                                <li className='clouser'>EPC and Integration services.</li>
                                                <li className='clouser'>Design and build customised refrigeration package.</li>
                                                <li className='clouser'>Manufacturing and assembly of components like Pressure vessels, Pipelines, Economizers etc.</li>
                                                <li className='clouser'>Installation and comissioning.</li>
                                                <li className='clouser'>IoT and AI based process Automation.</li>
                                            </ul>
                                        </div>     
                                    </div>
                                </div>
                                <div className="col-md-4 bdFadeRight">
                                    
                                    <div className="right-info-box">
                                         
                                        <div className="top">
                                          

                                            <div className="iocn-holder">
                                                <span className="flaticon-technology-1"></span>
                                            </div>
                                            <div className="text-holder">
                                                <h3>24/7 Customer Care</h3>
                                                <span>For Emergency Service</span>    
                                            </div>
                                        </div>
                                        <div className="middle">
                                            <h1>+91-83330-48451</h1>
                                            <p>We can provide expert 24 hour Emergency Service, contact when you need it!.</p>    
                                        </div>
                                        <div className="bottom">
                                            <h4>For queries:</h4>
                                            <ul>
                                                <li><span>Tel:</span> +91- 9500651222/9600615574</li>
                                                <li><span>Email:</span> dirsales@indusref.com </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End about us area--> */}

                    {/* <!--Start caption box area--> */}
                    <section className="caption-box-area bdFadeUp">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-holder pull-left">
                                        <h1>Continuously developing cutting-edge technologies</h1>
                                        <p>That reduce energy consumption and greenhouse gas emissions</p>
                                    </div>
                                    <div className="button pull-right">
                                        <a href="/contact">Learn more</a>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End caption box area--> */}

                    {/* <!--Start services area--> */}
                    <section className="services-area">
                        <div className="container">
                            <div className="sec-title center text-center">
                                <h1 className='title-anim'><span>Segments</span></h1>
                            </div>
                            <div className="row">
                                {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-air-conditioner-1"></span> */}
                                                        <span><img src='assets/images/Marketicons/01.webp' alt='icons'/></span> 
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>Food</h3>
                                            <p>Refrigeration solutions to ensure food freshness and safety</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}
                                {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="1s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-construction"></span> */}
                                                        <span><img src='assets/images/Marketicons/02.webp' alt='icons'/></span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>Dairy and Beverage</h3>
                                            <p>Energy-efficient refrigeration and Reliable refrigeration for efficient beverage manufacturing and quality.</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}
                              
                                {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="2s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-broom"></span> */}
                                                        <span><img src='assets/images/Marketicons/04.webp' alt='icons'/></span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>Pharma</h3>
                                            <p>Precise refrigeration for pharmaceutical safety and compliance</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}
                                {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="2.5s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-hot"></span> */}
                                                        <span><img src='assets/images/Marketicons/05.webp' alt='icons'/></span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>Oil / Gas / Power </h3>
                                            <p>Robust refrigeration for the oil, gas, and chemical industries.</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}
                                {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="3s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-up-arrow"></span> */}
                                                        <span><img src='assets/images/Marketicons/06.webp' alt='icons'/></span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>Cold Storage & WareHouse</h3>
                                            <p>Integrated cold storage for temperature-sensitive goods</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}

                                  {/* <!--Start single item--> */}
                                <div className="col-md-4 col-sm-12 col-xs-12 bdFadeUp">
                                    <div className="single-item hvr-float-shadow wow fadeInUp" data-wow-delay="1.5s" data-wow-duration="1s" data-wow-offset="0">
                                        <div className="icon-holder">
                                            <div className="icon-box">
                                                <div className="icon">
                                                    <div className="icon-bg">
                                                        {/* <span className="flaticon-write"></span> */}
                                                        <span><img src='assets/images/Marketicons/08.webp' alt='icons'/></span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-holder">
                                            <h3>General Industries</h3>
                                            <p>Reliable refrigeration for efficient beverage manufacturing and quality.</p>
                                            <a href="/indusref-markets">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single item--> */}
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="special-offers text-center bdFadeUp">
                                        <h3>Indus Refrigration provides a full range of <span>Industrial Refrigeration solutions and services</span></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End services area--> */}

                    {/* <!--Start appoinment area--> */}
                    <MakeAppoinment/>
                    {/* <!--End appoinment area--> */}

                    {/* <!--Start testimonial area--> */}
                    {/* <section className="testimonial-area">
                        <div className="container">
                            <div className="sec-title center text-center">
                                <h1><span>Customer Reviews</span></h1>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="testimonial-carousel slider-container">
                                    <Slider {...settings2}>
                                        <div className="single-item text-center">
                                            <div className="img-holder">
                                                <img src="assets/images/testimonial/1.png" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <h5>Water Damage Repair</h5>
                                                <p>Excellent service and swift repair and I get to keep my Phone. I feel Really great.</p>
                                            </div>
                                            <div className="client-info">
                                                <div className="name pull-left">
                                                    <h6>John Wiliamson</h6>
                                                    <p>Newyork City</p>
                                                </div>
                                                <div className="review-box pull-right">
                                                    <ul>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-item text-center">
                                            <div className="img-holder">
                                                <img src="assets/images/testimonial/2.png" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <h5>Broken Glass Repair</h5>
                                                <p>Great service as this was2nd repair with Mr.Fixit, excellent communication.</p>
                                            </div>
                                            <div className="client-info">
                                                <div className="name pull-left">
                                                    <h6>Astley Fletcher</h6>
                                                    <p>Los Angles</p>
                                                </div>
                                                <div className="review-box pull-right">
                                                    <ul>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="single-item text-center">
                                            <div className="img-holder">
                                                <img src="assets/images/testimonial/3.png" alt="indusrefServices"/>
                                            </div>
                                            <div className="text-holder">
                                                <h5>Water Damage Repair</h5>
                                                <p>Repaired my iPhone 6s through thorough examination, updated at all times.</p>
                                            </div>
                                            <div className="client-info">
                                                <div className="name pull-left">
                                                    <h6>Mitchel Starc</h6>
                                                    <p>California</p>
                                                </div>
                                                <div className="review-box pull-right">
                                                    <ul>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                        <li><i className="fa fa-star"></i></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="more-review-button">
                                        <a href="/Contact">Contact Us Now</a>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> */}
                    {/* <!--End testimonial area--> */}

                    {/* <!--Start Brand area-->   */}
                    <section className="brand-area bdFadeUp">
                        <div className="container">
                            <div className="sec-title center text-center">
                                <h1 className='title-anim'><span>Our Clients</span></h1>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="brand">
                                    <Slider {...settings}>
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/1.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/2.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/3.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/4.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/5.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/6.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/7.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/8.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/9.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        {/* <!--Start single item--> */}
                                        <div className="single-item">
                                            <a href="/"><img src="assets/images/brand/10.png" alt="BrandImage"/></a>
                                        </div>
                                        {/* <!--End single item--> */}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End Brand area-->      */}

                    {/* <!--Start latest blog area--> */}
                    <section className="latest-blog-area bdFadeUp">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="sec-title">
                                        <h1 className='title-anim'><span>Explore Our Recent Installation </span></h1>
                                    </div>
                                </div> 
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="blog-carousel">
                                    <Slider {...settings3}>
                                        {/* <!--Start single latest blog--> */}
                                        <div className="single-blog-post">
                                            <div className="img-holder">
                                                <img src="assets/images/Events/Customer_Install_3_370x200.webp" alt="indusrefServices"/>
                                                {/* <div className="overlay-style-one">
                                                    <div className="box">
                                                        <div className="content">
                                                            <a href="/"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="text-holder">
                                                <ul className="meta-info">
                                                    {/* <li><a href="/">M/s:Asvini Fisheries</a></li> */}
                                                    <li><a href="/">Bhimavaram.</a></li>
                                                </ul>
                                                <a href="/">
                                                    <h3 className="blog-title">Supply of Refpak System </h3>
                                                </a> 
                                                <div className="text">
                                                    <p>with 1no’s York Screw Compressor Block for capacity of 920kg/hr JBT IQF Freezer @ (-) 40°C SST and (+) 38°C SDT.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--End single latest blog--> */}
                                        {/* <!--Start single latest blog--> */}
                                        <div className="single-blog-post">
                                            <div className="img-holder">
                                                <img src="assets/images/Events/Events-3.webp" alt="indusrefServices"/>
                                                {/* <div className="overlay-style-one">
                                                    <div className="box">
                                                        <div className="content">
                                                            <a href="/"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="text-holder">
                                                <ul className="meta-info">
                                                    {/* <li><a href="/">M/S:Heritage foods India limited</a></li> */}
                                                    <li><a href="/">Poonamallee, Chennai.</a></li>
                                                </ul>
                                                <a href="/">
                                                    <h3 className="blog-title">Supply of Screw Package</h3>
                                                </a> 
                                                <div className="text">
                                                    <p>with 3no’s MYCOM SCREW compressor for 15ton Curd Chiller
Within 2hrs. </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--End single latest blog--> */}
                                        {/* <!--Start single latest blog--> */}
                                        <div className="single-blog-post">
                                            <div className="img-holder">
                                                <img src="assets/images/Events/Events-2.webp" alt="indusrefServices"/>
                                                {/* <div className="overlay-style-one">
                                                    <div className="box">
                                                        <div className="content">
                                                            <a href="/"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="text-holder">
                                                <ul className="meta-info">
                                                    {/* <li><a href="/">M/s:BMR Exports</a></li> */}
                                                    <li><a href="/"> Nellore.</a></li>
                                                </ul>
                                                <a href="/">
                                                    <h3 className="blog-title">Supply of Refpak System </h3>
                                                </a> 
                                                <div className="text">
                                                    <p>with 3No’s Mycom Screw Compressor Block for capacity of
750kg/hr Arico IQF Freezer @ (-) 40°C SST and (+) 38°C SDT</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--End single latest blog--> */}
                                        

                                   
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End latest blog area-->  */}
                    
                    {/* <!--Start newsletter area--> */}
                    {/* <section className="newsletter-area">
                        <div className="container">
                            <div className="sec-title center text-center">
                                <h1><span>Newsletter Subscribe</span></h1>
                                <p>Subscribe now and receive weekly newsletter with special offers and interesting activities.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="newsletter">
                                        <form className="newsletter-form">
                                            <div className="row">
                                                <div className="col-md-5">   
                                                    <div className="field-input">
                                                        <input type="text" name="form_name" value="" placeholder="Your Name" required=""/>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">   
                                                    <div className="field-input">
                                                        <input type="email" name="form_email" value="" placeholder="Email Address" required=""/>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <button className="#" type="submit">Subscribe</button>
                                                </div>
                                            </div>
                                        </form>    
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </section>      */}
                    {/* <!--End newsletter area-->      */}
            </main>
            <Footer/>
        </section>
    )}

    export default Home;